/**
 * ToDo: Update last seen of the chat. Maybe with the websocket?
 */
export function ChatView() {
    const buttonForSending = document.querySelector('button[data-chat-new-message-send]') as HTMLButtonElement;
    const newMessageEditor = document.querySelector('[data-chat-new-message-for]') as HTMLTextAreaElement;

    if (!buttonForSending || !newMessageEditor) {
        return;
    }

    const sendMessage = async () => {
        const request = fetch(`/messages/chat/${newMessageEditor.dataset.chatNewMessageFor}/send`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                message: newMessageEditor.value,
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    newMessageEditor.innerHTML = '';

                    // ToDo: Load chat with websocket
                    location.reload();
                }

                if (!data.success) {
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    buttonForSending?.addEventListener('click', sendMessage, {passive: true});

// // @see https://github.com/fvilers/tiny-editor?tab=readme-ov-file#how-to-dynamically-create-an-editor
// // @ts-ignore
// window.__tinyEditor.transformToEditor(newMessageEditor);
}

ChatView();
